module.exports = __webpack_public_path__ + "img/icons1.bb30be85.png";